import { render, staticRenderFns } from "./RegisterHome.vue?vue&type=template&id=918e5ea8&"
import script from "./RegisterHome.vue?vue&type=script&lang=js&"
export * from "./RegisterHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports